module.exports = __webpack_public_path__ + "img/ai-hand.38a56f52.svg";